import { GraphQLInputObjectType, GraphQLNonNull, GraphQLString } from 'graphql'

export interface RouteDeleteMutationArgs {
  readonly input?: {
    readonly organizationUuid: string
    readonly applicationUuid: string
    readonly routeHash: string
  }
}

export const routeDeleteMutationArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'RouteDeleteMutationArgs',
      description:
        'Parameters that describe a delete operation for single route',
      fields: () => ({
        organizationUuid: {
          description: 'The ID of the organization of the route being deleted',
          type: new GraphQLNonNull(GraphQLString)
        },
        applicationUuid: {
          description: 'The ID of the application',
          type: new GraphQLNonNull(GraphQLString)
        },
        routeHash: {
          description: 'routeHash of the route',
          type: new GraphQLNonNull(GraphQLString)
        }
      })
    })
  }
}
